import { render, staticRenderFns } from "./banner-reduction-select.vue?vue&type=template&id=80054f58"
import script from "./banner-reduction-select.vue?vue&type=script&lang=js"
export * from "./banner-reduction-select.vue?vue&type=script&lang=js"
import style0 from "./banner-reduction-select.vue?vue&type=style&index=0&id=80054f58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports